import { fetch } from '@nackle/studio-tools';
import { serviceAwardsURL } from 'endpoints';
import ServiceAwardsSDK from '@nackle/service-awards-sdk';

export default function ServiceAwardsService() {

    const sdk = new ServiceAwardsSDK( serviceAwardsURL, fetch );

    return {
        getPrograms: sdk.getPrograms,
        getMilestones: sdk.getMilestones,
        searchRecipients: sdk.searchCelebrationsAdmin,
        deleteRecipients: sdk.deleteRecipients,
        updateRecipients: sdk.updateRecipients
    };
}